module.exports = __webpack_public_path__ + "static/media/buildingConstruction29.23ccbd1f.png";